let integrator;
let navState = {
    currentIndex: 0,
    maxIndex: 0,
    nextIndex: 0,
    prevIndex: 0,
}

function start() {
    integrator.navigate(0);
}

function back() {
    integrator.navigate(navState.prevIndex);
}

function next() {
    integrator.navigate(navState.nextIndex);
}

function configure(language) {
    const config = {
        defaultSelection: 3,
        language: language,
        randomImages: false,
        refreshToken: false,
        showBrandLogo: false,
        showEmptyRows: false,
        showImage: false,
        showLargeImage: false,
        showLicensePlate: false,
        showOptionPrice: false,
        showStepper: true,
        showVehiclePrice: false,
        showVehicleTypeLogo: false,
        token: false,
        useBrandModelSearch: true,
        useBuildSearch: true,
        useCatalogSearch: false,
        useConfigurator: false,
        useCustomizationCapabilities: false,
        useEcoSearch: false,
        useEnergyLabelApi: false,
        useFactoryCodeSearch: false,
        useLicensePlateSearch: true,
        useMoto: false,
        useOnlyBrands: [],
        usePassengerCar: true,
        useRandomImageIndex: false,
        useRegistrationNumberSearch: false,
        useSelection: true,
        useSummary: false,
        useTypeCertificateSearch: false,
        useUtilityCar:false,
        useVinSearch: false,
        customStyleSrc: window.location.origin + '/css/scf.css',
    };
    integrator.config = {...integrator.config, ...config};
    integrator.configure();
}

function authorize(token) {
    integrator.authorization = {token};
    integrator.authorize();
}

function refresh(token) {
    integrator.refresh(token);
}

function hide() {
    integrator.hideIframe();
}

function initialize(token) {
    integrator.authorization = {token};
    integrator.init();
}

function dispatch() {
    integrator.dispatch();
}

function destroy() {
    integrator.destroy();
}

function reset() {
    integrator.reset();
}

function show() {
    integrator.showIframe();
}

function log(event, payload) {
    if (__debug) {
        console.log(`[ScfIntegrator]\n\tEvent:\t "${event}"\n\tPayload:`, payload);
    }
}

window.addEventListener('message', function (e) {
    if (e.data === 'loaded') {
        integrator.passConfig();
    }
});

function loadSCFIntegrator(node, language, iframeSrc, scfAutoDispatch, scfDispatch, scfNavigationStateChange, token) {
    const js = document.createElement('script');
    js.src = 'https://iframe.autoi.ch/smartcarfinder/scripts/dist/scf-integrator.min.js';

    js.onload = () => {
        integrator = window.scfIntegrator

        integrator.authorization = {
            token: '',
        };

        integrator.config = {};

        integrator.host = {
            node: node,
            iframeSrc: iframeSrc,
        };

        // We need set initial config. This fix for bug with languages when their not loaded.
        configure(language);

        integrator.events = {
            onAutoDispatch: (x) => {
                log('onAutoDispatch', x);
                scfAutoDispatch(x);
            },
            onAuthorized: () => {
                log('onAuthorized');
            },
            onCanDispatch: (x) => {
                log('onCanDispatch', x);

                if (x === 1) {
                    //todo
                } else if (x === 2) {
                    //todo
                }
            },
            onDispatch: (x) => {
                log('onDispatch', x);
                scfDispatch(x);
            },
            onLoaded: () => {
                log('onLoaded');
                configure(language);
            },
            onNavigationStateChange: (x) => {
                navState = x;
                scfNavigationStateChange(x);
                log('onNavigationStateChange', x);
            },
            onUnauthorized: () => {
                log('onUnauthorized');
                console.log(integrator.authorization.token);
                authorize(integrator.authorization.token);
            },
        };

        // authorize(token);
        initialize(token);
    };

    window.document.body.appendChild(js);
}

export {loadSCFIntegrator, authorize, initialize, reset, back, hide, show, start};
